import React from "react"
import CustomButton from "components/Atoms/CustomButton"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import RemoveButton from "components/Molecules/RemoveButton"
import { TIME_SLOTS } from "graphql/selector.queries.gql"
import { startCase } from "lodash-es"
import CustomTag from "components/Atoms/CustomTag"
import { ContractDetailsQuery } from "generated/graphql"
interface ContractExpensesProps {
  disabled?: boolean
  expenses?: ContractDetailsQuery["contractDetails"]["contractrecurringexpenseSet"]
  onRemove: (index: number) => void
  onAdd: () => void
  type: any
}
const ContractExpenses = ({
  type,
  disabled,
  expenses,
  onRemove,
  onAdd,
}: ContractExpensesProps) => {
  return (
    <>
      <div className="flex items-baseline">
        <h6 className="mt-6 mb-0 vt-section-header">Recurring Expenses</h6>

        <CustomButton
          icon="plus"
          minimal
          intent="success"
          disabled={disabled}
          onClick={e => onAdd()}
        />
      </div>
      {/* Should be populated with contractType */}
      <p className="text-sm mb-2 vt-muted">
        <span className="vt-highlight vt-warning">{startCase(type?.name)}</span>{" "}
        rates for a particular date in the contract period
      </p>
      <hr className="mt-0" />
      <div className="grid grid-cols-12 gap-4 mb-2">
        <div className="col-span-3">Unit Count</div>
        <div className="col-span-3">Unit Rate (₹)</div>
        <div className="col-span-3">Shift (time slot)</div>
      </div>
      {expenses?.map((exp, idx) => {
        // Extract a variable here so we don't have to repeat the entire string again
        // and again

        const path = `contractrecurringexpenseSet.${idx}`
        return (
          <div
            key={exp?.id ?? `expense-${idx}`}
            className="grid grid-cols-12 gap-4"
          >
            <div className="col-span-3">
              <StringInput
                disabled={disabled}
                placeholder="Unit Count"
                path={`${path}.unitCount`}
                rightElement={<CustomTag minimal>{type?.codename}</CustomTag>}
              />
            </div>
            <div className="col-span-3">
              <StringInput
                disabled={disabled}
                placeholder="Rate"
                path={`${path}.cost`}
              />
            </div>
            <div className="col-span-3">
              <DynamicSelector
                disabled={disabled}
                big
                path={`${path}.shift`}
                query={TIME_SLOTS}
              />
            </div>
            <div className="col-span-3">
              <RemoveButton
                disabled={disabled}
                icon="minus"
                intent="danger"
                onClick={(e: any) => onRemove(idx)}
              />
            </div>
          </div>
        )
      })}
    </>
  )
}

export default ContractExpenses
